<template>
   <div id="contact-info-wrapper">
      <section class="contact-info-container container">
         <div class="row">
            <div class="col-12">
               <div class="contact-card" v-if="contactInfo">
                  <!-- Add to Contacts Button -->
                  <button class="add-to-contacts-btn" @click="addToContacts">
                     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <line x1="19" y1="8" x2="19" y2="14"></line>
                        <line x1="22" y1="11" x2="16" y2="11"></line>
                     </svg>
                     Add to Contacts
                  </button>

                  <div class="contact-info">
                     <div class="info-item">
                        <span class="label">Full Name</span>
                        <span class="value">{{ contactInfo.fullName }}</span>
                     </div>
                     <div class="info-item">
                        <span class="label">Title / Position</span>
                        <span class="value">{{ contactInfo.title }}</span>
                     </div>

                     <div class="info-item">
                        <span class="label">Mobile Phone</span>
                        <a :href="'tel:' + contactInfo.mobilePhone" class="value link">{{ contactInfo.mobilePhone }}</a>
                     </div>

                     <div class="info-item">
                        <span class="label">Email Address</span>
                        <a :href="'mailto:' + contactInfo.email" class="value link">{{ contactInfo.email }}</a>
                     </div>

                     <div class="info-item">
                        <span class="label">Company</span>
                        <span class="value">{{ contactInfo.company }}</span>
                     </div>
                  </div>

                  <!-- Office Information Section -->
                  <div class="offices-section">
                     <div class="office-card">
                        <h4 class="office-name">German Headquarters</h4>
                        <div class="office-details">
                           <p class="office-address">Stresemannstr. 342, 22761<br />Hamburg/Deutschland</p>
                           <a :href="'tel:+4940226138370'" class="office-contact">+49 40/22 61 38 37 0</a>
                           <a :href="'mailto:info@gtsfly.de'" class="office-contact">info@gtsfly.de</a>
                        </div>
                     </div>

                     <div class="office-card">
                        <h4 class="office-name">Türkiye DMC Office</h4>
                        <div class="office-details">
                           <p class="office-address">Güzeloba Mah. Havaalanı Cad. No:37<br />İç Kapı No:103 Muratpaşa / Antalya PK:07230</p>
                           <a :href="'tel:+902425245303'" class="office-contact">+90 242 524 53 03</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="contact-card" v-else>
                  <div class="error-message">
                     <p>Person information not found.</p>
                  </div>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>

<script>
export default {
   name: "PersonInfo",
   data() {
      return {
         contactInfo: null,
         peopleData: {
            "serkan.yildiz": {
               fullName: "Serkan Yıldız",
               mobilePhone: "+49 176 105 45270",
               email: "serkan.yildiz@gtsfly.de",
               company: "GTS Global Travel Services GmbH",
               title: "CEO",
            },
            // Buraya yeni kişiler eklenebilir
            // "ahmet.yilmaz": {
            //    fullName: "Ahmet Yılmaz",
            //    mobilePhone: "+90 555 123 45 67",
            //    email: "ahmet.yilmaz@gtsfly.de",
            //    company: "GTS Global Travel Services GmbH",
            //    title: "CTO",
            // },
         },
      };
   },
   created() {
      const self = this;
      self.$store.state.header = "light";

      // Route parametresinden kişi bilgisini al
      const personId = self.$route.params.person;
      self.contactInfo = self.peopleData[personId] || null;

      // Sayfa yüklendiğinde otomatik olarak contact açılsın
      if (self.contactInfo) {
         // Biraz bekle ki DOM hazır olsun
         setTimeout(() => {
            self.addToContacts();
         }, 500);
      }
   },
   watch: {
      "$route.params.person": function (newPerson) {
         // Route değiştiğinde kişi bilgisini güncelle
         this.contactInfo = this.peopleData[newPerson] || null;
      },
   },
   methods: {
      addToContacts() {
         const contact = this.contactInfo;
         if (!contact) return;

         // VCF (vCard) formatında veri oluştur
         const vcard = `BEGIN:VCARD
VERSION:3.0
FN:${contact.fullName}
N:${contact.fullName.split(" ").reverse().join(";")};;;
ORG:${contact.company}
TITLE:${contact.title}
TEL;TYPE=CELL:${contact.mobilePhone}
EMAIL:${contact.email}
END:VCARD`;

         // iOS için data URL kullan (direkt contact picker açar)
         const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

         if (isIOS) {
            // iOS için data URL
            const dataUrl = "data:text/vcard;charset=utf-8," + encodeURIComponent(vcard);
            window.location.href = dataUrl;
         } else {
            // Android için blob + download attribute
            const blob = new Blob([vcard], { type: "text/vcard" });
            const url = window.URL.createObjectURL(blob);

            // Link elementi oluştur
            const link = document.createElement("a");
            link.href = url;
            link.download = `${contact.fullName.replace(/\s+/g, "_")}.vcf`;

            // Link'i DOM'a ekle, tıkla ve kaldır
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Cleanup
            setTimeout(() => {
               window.URL.revokeObjectURL(url);
            }, 100);
         }
      },
   },
};
</script>

<style lang="scss" scoped>
#contact-info-wrapper {
   min-height: 100vh;
   background: linear-gradient(135deg, #f7f9ff 0%, #ffffff 100%);
   padding: 1rem 0;

   .container {
      padding: 1rem 0;
   }

   .contact-card {
      background: #ffffff;
      border-radius: 1rem;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      padding: 2rem;
      max-width: 600px;
      margin: 0 auto;
      position: relative;

      .add-to-contacts-btn {
         width: 100%;
         background: #32b8fb;
         color: #ffffff;
         border: none;
         border-radius: 0.5rem;
         padding: 0.875rem 1.5rem;
         font-size: 1rem;
         font-weight: 600;
         cursor: pointer;
         display: flex;
         align-items: center;
         justify-content: center;
         gap: 0.5rem;
         margin-bottom: 1.5rem;
         transition: all 0.2s ease-in-out;
         box-shadow: 0 2px 8px rgba(50, 184, 251, 0.2);

         svg {
            width: 20px;
            height: 20px;
         }

         &:hover {
            background: #2a9dd9;
            box-shadow: 0 4px 12px rgba(50, 184, 251, 0.3);
            transform: translateY(-1px);
         }

         &:active {
            transform: translateY(0);
         }
      }

      .contact-info {
         display: flex;
         flex-direction: column;
         gap: 1.25rem;

         .info-item {
            display: flex;
            flex-direction: column;
            gap: 0.35rem;
            padding-bottom: 0.75rem;
            border-bottom: 1px solid #efefef;

            &:last-child {
               border-bottom: none;
               padding-bottom: 0;
            }

            .label {
               font-size: 0.875rem;
               font-weight: 600;
               color: #000000;
               text-transform: uppercase;
               letter-spacing: 0.1rem;
            }

            .value {
               font-size: 1.5rem;
               font-weight: 400;
               color: #44484f;

               &.link {
                  color: #32b8fb;
                  text-decoration: none;
                  transition: all 0.2s ease-in-out;

                  &:hover {
                     color: #2a9dd9;
                     text-decoration: underline;
                  }
               }
            }
         }
      }

      .error-message {
         text-align: center;
         color: #44484f;
         font-size: 1.125rem;
         padding: 2rem 0;
      }

      .offices-section {
         margin-top: 2rem;
         padding-top: 1.5rem;
         border-top: 2px solid #f0f0f0;

         .offices-title {
            font-size: 1.25rem;
            font-weight: 600;
            color: #32b8fb;
            margin-bottom: 1.25rem;
            text-transform: uppercase;
            letter-spacing: 0.1rem;
         }

         .office-card {
            // background: #f7f9ff;
            border-radius: 0.75rem;
            // padding: 1.25rem;
            margin-bottom: 2rem;

            &:last-child {
               margin-bottom: 0;
            }

            .office-name {
               font-size: 1.125rem;
               font-weight: 600;
               color: #44484f;
               margin-bottom: 0.75rem;
            }

            .office-details {
               display: flex;
               flex-direction: column;
               gap: 0.35rem;

               .office-address {
                  color: #44484f;
                  font-size: 1rem;
                  line-height: 1.6;
                  margin: 0;
               }

               .office-contact {
                  color: #32b8fb;
                  font-size: 1rem;
                  text-decoration: none;
                  transition: all 0.2s ease-in-out;

                  &:hover {
                     color: #2a9dd9;
                     text-decoration: underline;
                  }
               }
            }
         }
      }
   }

   @media (max-width: 768px) {
      padding: 0.75rem 0;

      .container {
         padding: 1rem 0;
      }

      .contact-card {
         padding: 1.5rem 1.25rem;
         border-radius: 0.75rem;

         .add-to-contacts-btn {
            font-size: 0.95rem;
            padding: 0.8rem 1.25rem;
            margin-bottom: 1.25rem;
         }

         .contact-info {
            gap: 1.125rem;

            .info-item {
               padding-bottom: 0.75rem;

               .label {
                  font-size: 0.75rem;
               }

               .value {
                  font-size: 1.25rem;
               }
            }
         }

         .offices-section {
            margin-top: 1.5rem;
            padding-top: 1.25rem;

            .offices-title {
               font-size: 1.125rem;
               margin-bottom: 1rem;
            }

            .office-card {
               padding: 1.125rem;
               margin-bottom: 0.875rem;

               .office-name {
                  font-size: 1.125rem;
               }
            }
         }
      }
   }

   @media (max-width: 480px) {
      .contact-card {
         padding: 1.25rem 1rem;

         .add-to-contacts-btn {
            font-size: 0.9rem;
            padding: 0.75rem 1rem;
            margin-bottom: 1rem;
         }

         .contact-info {
            gap: 1rem;

            .info-item {
               padding-bottom: 0.65rem;

               .value {
                  font-size: 1.125rem;
                  word-break: break-word;
               }
            }
         }

         .offices-section {
            margin-top: 1.25rem;
            padding-top: 1.125rem;

            .offices-title {
               font-size: 1rem;
               margin-bottom: 1rem;
            }

            .office-card {
               padding: 1rem;
               margin-bottom: 0.75rem;

               .office-name {
                  font-size: 1rem;
               }

               .office-details {
                  .office-address,
                  .office-contact {
                     font-size: 0.9rem;
                  }
               }
            }
         }
      }
   }
}
</style>
